import { render } from "./MarketplaceFilter.vue?vue&type=template&id=f9864658"
import script from "./MarketplaceFilter.vue?vue&type=script&lang=js"
export * from "./MarketplaceFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__